module.exports = __webpack_public_path__ + "img/about1.c872e911.png";